<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_ORDER_EXPORT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu xuất kho</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="exportExcel"
          v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_ORDER_EXPORT_VIEW')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate1()"
              v-model="dateRange1"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian xuất
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Số phiếu xuất"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryIdExport"
              :options="optionInventory"
              placeholder="Kho xuất"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reasonExport"
              :options="Config.getSearch(Config.reasonExport)"
              placeholder="Lý do xuất"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryIdImport"
              :options="optionInventory"
              placeholder="Kho nhận"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>

          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keySearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.contractCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã HĐ/PL"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="d-flex">
          <div
            v-if="hasDefaultFilter"
            class="mb-2 d-inline-flex align-items-center"
            style="
              background-color: #fff3e0;
              padding: 6px 12px;
              border-radius: 4px;
              font-size: 13px;
            "
          >
            <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
            <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
            <button
              @click="removeDefaultFilter"
              type="button"
              class="ml-2 btn-close-filter"
              style="
                background: none;
                border: none;
                cursor: pointer;
                padding: 0 4px;
                color: #e65100;
                font-size: 16px;
                line-height: 1;
              "
              title="Bỏ lọc"
            >
              ×
            </button>
          </div>
          <div class="box-header"><b>Tổng</b>: {{ pagination.total }}</div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              sticky-header
              hover
              responsive
              :items="dataExport"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <span
                  ><b>Thời gian tạo</b>:
                  {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</span
                ><br />
                <span
                  ><b>Thời gian xuất</b>:
                  {{ data.item.timeExport | formatDate('HH:mm, DD/MM/YYYY') }}</span
                >
              </template>
              <template #cell(inventoryNameImport)="data">
                <span> {{ data.item.merchantName }}</span> <br />
                <span class="text-primary"> {{ data.item.merchantEmail }}</span> <br />
                <span> {{ data.item.merchantPhone }}</span>
              </template>
              <template #cell(userCreator)="data">
                {{ data.item.userCreator.name }} <br />
                <span class="text-primary">{{ data.item.userCreator.email }}</span>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(reasonExport)="data">
                {{ data.item.reasonExport | transformData(Config.reasonExport) }}
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button class="dropdown-item" @click="onRowSelected(data.item)">
                    <span>&nbsp;</span>Chi tiết
                  </button>
                  <button class="dropdown-item" @click="inTicket(data.item.id)">
                    <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'billNumber', label: 'Mã phiếu' },
    { key: 'time', label: 'Thời gian' },
    { key: 'quantityExport', label: 'Tổng TB xuất', class: 'text-center' },
    { key: 'inventoryNameExport', label: 'Kho xuất' },
    { key: 'reasonExport', label: 'Lý do xuất' },
    { key: 'inventoryNameImport', label: 'Thông tin MC' },
    { key: 'userCreator', label: 'Người tạo' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'contractCode', label: 'Số HĐ/PL' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        loading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataExport: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        dateRange1: {
          startDate: null,
          endDate: null,
        },
        optionStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusExportWarehouse],
        optionInventory: [],
        fieldsTable,
        filterTable: fieldsTable,
        hasDefaultFilter: true,
      }
    },
    mixins: [prepareQueryParamsMixin],
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    created() {
      this.getListInventory()
      this.transformDate()
      this.fetchData()
    },
    methods: {
      async inTicket(id) {
        this.loading = true
        try {
          const res = await DeviceService.detailExportWarehouse({ id })
          const data = res.data
          data.devicesTotalAmount = data.devices.reduce((t, i) => t + i.price, 0)
          data.isNganluongContract = data.contractCode.endsWith('NL-CNTT')
          await DeviceService.inExportTicket({ data })
        } catch (error) {
        } finally {
          this.loading = false
        }
      },
      onRowSelected(item) {
        window.open(`/export-warehouse/${item.id}`, '_blank')
      },
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDate1() {
        this.search.timeExportFrom = moment(this.dateRange1.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.timeExportTo = moment(this.dateRange1.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            this.optionInventory = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionInventory.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async exportExcel() {
        try {
          delete this.search.page
          delete this.search.limit
          await DeviceService.exportExcelExportWarehouse(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.hasDefaultFilter = false
        this.dateRange = { startDate: null, endDate: null }
        this.search.dateFrom = null
        this.search.dateTo = null
        this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          if (this.search.status === '0') delete this.search.status
          if (this.search.inventoryIdImport === '0') delete this.search.inventoryIdImport
          if (this.search.inventoryIdExport === '0') delete this.search.inventoryIdExport
          if (this.search.reasonExport === '0') delete this.search.reasonExport
          if (this.dateRange.startDate === null) delete this.search.dateFrom
          if (this.dateRange.endDate === null) delete this.search.dateTo
          if (this.dateRange1.startDate === null) delete this.search.timeExportFrom
          if (this.dateRange1.endDate === null) delete this.search.timeExportTo
          const data = await DeviceService.listExportWarehouse(this.search)
          if (data.success) {
            this.dataExport = data.data.orders ? data.data.orders : []
            this.pagination.total = data.data.count ? data.data.count : 0
          } else {
            this.dataExport = []
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style></style>
